import styled from 'styled-components';
import { lighten } from 'polished';
import { Link } from 'react-router-dom';
import * as cor from '../../styles/colors';
import InputForm from '../../components/Form/Input';

export const Container = styled.div`
  height: 100%;
  background: ${cor.fundoLogin};
  background-size: 29px 22px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContainerButton = styled.div`
  align-items: center;
  margin-top: 16px;
`

export const Input = styled(InputForm)`
  margin-bottom: 5px;
`

export const Content = styled.div`
  width: 90%;
  max-width: 450px;
  text-align: center;
  background-color: ${cor.fundoPainelLogin};
  padding: 25px 18px;
  border: solid ${cor.corBordaLogin} 1px;
  box-shadow: 3px 3px 6px ${cor.corSombraBordaLogin};  

  img {
    width: 70%;
  }

  form {
    display: flex;
    flex-direction: column;
    margin-top: 0px;

    button {
      margin: 5px 0 0;
      height: 44px;
      width: 200px;
      background: ${cor.fundoTopo};
      font-weight: bold;
      color: #fff;
      border: 0px;
      border-radius: 5px;
      font-size: 15px;
      transition: background 0.2s;
      :hover {
        background-color: ${lighten(0.04, cor.fundoTopo)}
      }
      align-self: center;
    }

    a {
      margin-top: 10px;
      text-decoration: none;
      color: ${cor.fundoTopo};
      cursor: pointer;
    }
  }
`

export const PassContainer = styled.div`
  position:relative;
  input {
    width: 100%;
    padding-right: 53px !important;
  }
`

export const ShowPass = styled.div`
  width: 29px;
  float: right;
  margin-right: 15px;
  margin-top: -34px;
  position: relative;
  
  img {
    width: 100%;
  }
`

export const ForgotText = styled(Link)`
  align-self: flex-end;
  margin: 0 10px 20px !important;
  color: #666 !important;
`

export const TextContainer = styled.div`
  padding: 0px 15px;
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
`

export const TextButton = styled.a`
  font-size: 14px;
`